import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { Controller } from 'react-hook-form';
import { getFloorLabel } from 'utility/utilityFunctions';

type FloorSelectProps = {
  control: any;
  floor?: number; // total floors (>=1)
  cellar?: boolean; // whether cellar exists
  otherOptions?: string[]; // previously used custom floor labels
  onOtherSelect?: (isOther: boolean) => void;
};

const FloorSelect: React.FC<FloorSelectProps> = ({
  control,
  floor,
  cellar,
  otherOptions = [],
  onOtherSelect,
}) => {
  // build options dynamically
  const options: { label: string; value: string }[] = [];

  if (cellar) {
    options.push({ label: 'Cellar', value: '-1' });
  }

  if (floor && floor >= 1) {
    for (let i = 0; i < floor; i++) {
      if (i === 0) {
        options.push({ label: 'Ground floor', value: '0' });
      } else {
        options.push({
          label: `${i}${getFloorLabel(i)} floor`,
          value: i.toString(),
        });
      }
    }
  }

  return (
    <FormGroup>
      <Label for="floor">Floor *</Label>
      <Controller
        name="floor"
        control={control}
        render={({ field }) => (
          <>
            <Input
              {...field}
              id="floor"
              type="select"
              onChange={e => {
                field.onChange(e);
                if (onOtherSelect) onOtherSelect(e.target.value === 'other');
              }}
            >
              <option value="">-- Select Floor --</option>
              {options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
              <option value="other">Other</option>
            </Input>
            {otherOptions.length > 0 && (
              <datalist id="custom-floor-list">
                {otherOptions.map(opt => (
                  <option key={opt} value={opt} />
                ))}
              </datalist>
            )}
          </>
        )}
      />
    </FormGroup>
  );
};

export default FloorSelect;
